(() => {
  'use strict';
  const minimumQuantity = 10;
  const maximumQuantity = 999;
  const maximumCheckoutQuantity = 99;
  const quote = ({ policy, variant, quantity, currency, style = 'same', live = false, qualified = false }) => {
    const valid = Number.isInteger(quantity) && quantity >= minimumQuantity && quantity <= maximumQuantity;
    const price = variant?.price;
    if (!valid || !Number.isSafeInteger(price) || price <= 0 || !currency) return { valid: false, reason: 'invalid' };
    const baseTotal = price * quantity;
    const rule = policy?.variants?.[String(variant.id)];
    const current = policy?.version === 1 && policy.currency === currency;
    const eligible = Boolean(current && rule?.basePrice === price && style === 'same');
    const candidates = eligible ? (rule.tiers || policy.tiers || []).filter(t => Number.isInteger(t.quantity) && t.quantity >= minimumQuantity && t.quantity <= maximumQuantity && Number.isInteger(t.percent) && t.percent >= 0 && t.percent <= rule.maxPercent && t.percent < 100).sort((a, b) => a.quantity - b.quantity) : [];
    const tiers = candidates.filter((tier, index) => !candidates.slice(0, index).some(previous => previous.percent > tier.percent || previous.quantity === tier.quantity));
    const tier = tiers.filter(t => quantity >= t.quantity).at(-1);
    const percent = tier?.percent || 0;
    // Each tier is the total discount from the listed price, including any 5% offer.
    // Shopify's native percentage rule floors the per-unit discount in cents.
    const unit = price - Math.floor(price * percent / 100);
    const total = unit * quantity;
    return { valid, eligible, percent, unit, total, baseTotal, savings: baseTotal - total, activeQuantity: tier?.quantity,
      tiers, next: tiers.find(t => t.quantity > quantity && t.percent > percent) || null,
      estimated: percent > 0 && !(live === true && qualified === true),
      canOrder: style === 'same' && eligible && live === true && qualified === true,
      reason: style !== 'same' ? 'names' : quantity > maximumCheckoutQuantity && live !== true ? 'volume' : eligible ? 'eligible' : 'unverified' };
  };
  globalThis.JaxBulkPricing = Object.freeze({ minimumQuantity, maximumQuantity, maximumCheckoutQuantity, quote });
})();
